import React, { useState, useEffect } from "react";
import { useDispatch, connect } from "react-redux";
import {
  Row, Col, Card, CardBody, 
  CardTitle, CardHeader, 
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown
} from "reactstrap";
import {
  Table, Thead, Tbody, Tr, Th, Td
} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Link } from "react-router-dom";

// i18n
import { withTranslation } from "react-i18next";
import CustomPagination from "components/Common/CustomPagination";
import TableLoader from "components/Common/TableLoader";
import { 
  fetchClientWithdrawals, withdrawApproveStart, withdrawRejectStart 
} from "store/transactions/withdrawal/action";
import {
  depositRejectStart, 
  depositApproveStart,
  fetchClientDeposits  
} from "store/transactions/deposit/action";
// import Notification from "components/Common/Notification";
// import logo from "assets/images/logo-sm.svg";
import { captilazeFirstLetter } from "common/utils/manipulateString";
import { formatDateBroker } from "helpers/formatDate";
import Badge from "components/Common/Badge";
import OriginDetailsButton from "components/Common/OriginDetails";
import ReceiptModal from "pages/Transactions/Forex/ReceiptModal";
import { fixingAmount } from "common/utils/FixedAmount";
import TransactionModal from "components/Common/TransactionModal";


function ClientTransactions(props) {
  const clientId = props.clientId;
  // const [showNotication, setShowNotifaction] = useState(false);
  const [btnprimary1, setBtnprimary1] = useState(false);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedDeposit, setSelectedDeposit] = useState({});

  const transactionTypes = [
    { 
      key: "Withdrawal", 
      label: props.t("Withdrawal") 
    },
    { 
      key: "Deposit", 
      label: props.t("Deposit") 
    }
  ];
  const [selectedTransactionType, setSelectedTransactionType] = useState("Withdrawal");
  const dispatch = useDispatch();

  const changeTransactionTypeHandler = (key) => {
    setPage(1);
    setSelectedTransactionType(key);
  };
  const loadClientTransactionsdetails = (newPage = page, newLimit = sizePerPage) => {
    if (selectedTransactionType === "Deposit") {
      dispatch(fetchClientDeposits({
        clientId,
        type: "LIVE",
        walletType: "customers",
        page: newPage,
        limit: newLimit
      }));
    } else {
      dispatch(fetchClientWithdrawals({
        clientId,
        type: "LIVE",
        walletType: "customers",
        page: newPage,
        limit: newLimit
      }));
    }
  };
  useEffect(() => {
    loadClientTransactionsdetails(1, sizePerPage);
    setPage(1);
  }, [selectedTransactionType, sizePerPage]);

  const depositApproveModal = (deposit) => {
    setSelectedDeposit(deposit);
    setApproveModal(true);
  };

  const depositRejectModal = (deposit) => {
    setSelectedDeposit(deposit);
    setRejectModal(true);
  };

  const depositApprove = (deposit)=>{
    dispatch(depositApproveStart({
      id: deposit._id,
      customerId: deposit.customerId._id,
      amount: deposit.amount,
      note: deposit.note
    }));
    setApproveModal(false);
    // setShowNotifaction(true);
  };
  const depositReject = (deposit)=>{
    dispatch(depositRejectStart({
      id: deposit._id,
      customerId: deposit.customerId._id,
      note: deposit.note
    }));
    setRejectModal(false);
    // setShowNotifaction(true);
  };
  // const closeNotifaction = () => {
  //   setShowNotifaction(false);
  // };

  const withdrawApprove = (withdrawal) => {
    dispatch(withdrawApproveStart({
      id: withdrawal._id,
      customerId: withdrawal.customerId._id 
    }));
    // setShowNotifaction(true);
  };
  const withdrawReject = (withdrawal) => {
    dispatch(withdrawRejectStart({
      id: withdrawal._id,
      customerId: withdrawal.customerId._id 
    }));
    // setShowNotifaction(true);
  };

  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState("");

  const columns = [
    {
      dataField: "checkbox",
      text: <input type="checkbox"/>
    },
    {
      dataField: "createdAt",
      text: props.t("Creation Date"),
      formatter: (val) => formatDateBroker(val.createdAt)
    },
    {
      dataField: "updatedAt",
      text: props.t("Approval/Reject Date"),
      formatter: (val) => val?.status === "PENDING" ? "-" : formatDateBroker(val.updatedAt)
    }, 
    {
      dataField: "customerId",
      text: props.t("Client"),
      formatter:(val)=>(val.customerId ? `${captilazeFirstLetter(val.customerId?.firstName)} ${captilazeFirstLetter(val.customerId?.lastName)}` : "")
    },
    {
      dataField: "gateway",
      text: props.t("Gateway"),
      formatter: (val) => (val.gateway == "WIRE_TRANSFER" ? "Wire" : val.gateway?.split("_").join(" ")?.toLowerCase())
    },
    {
      dataField: "currency",
      text: props.t("Currency")    
    },
    selectedTransactionType === "Deposit" && {
      dataField: "to",
      text: props.t("To"),
      formatter: (val) => (
        val.to?.length >= 10 ? val.to.substr(0, 4) + "....." + val.to.substr(-5, 4) : val.to
      )
    },
    selectedTransactionType === "Withdrawal" && {
      dataField: "from",
      text: props.t("From"),
      formatter: (val) => (
        val.from?.length >= 10 ? val.from.substr(0, 4) + "....." + val.from.substr(-5, 4) : val.from
      )
    },
    {
      dataField: "status",
      text: props.t("Status"),
      formatter: (val) => <Badge status={props.t(val.status)}></Badge>,
    },
    {
      dataField: "reason",
      text: props.t("Reason"),
      formatter: (item) => (
        item.reason ? item.reason : "-"
      )
    },
    {
      dataField: "bankReceipt",
      text: props.t("Bank Receipt"),
      formatter: (val) => {
        if (val?.receipt) {
          return (
            <div className="text-center">
              <div className={val?.receipt ? "text-success" : "text-muted "}
                style={{
                  cursor: "pointer",
                }}
              >
                <i
                  className="mdi mdi-eye font-size-20"
                  id="edittooltip"
                  onClick={() => {
                    if (["WIRE_TRANSFER", "UPI", "CRYPTO", "MANUAL"].includes(val?.gateway)) {
                      setDetailsModal(true);
                      setSelectedContent({
                        type: "image",
                        content: val?.receipt,
                      });
                    }
                  }}
                ></i>
              </div>
            </div>
          );
        } else {
          return (
            <div className="text-center">
              <div className={"text-muted "}>
                <i className="mdi mdi-eye font-size-20" id="edittooltip"></i>
              </div>
            </div>
          );
        }
      },
    },
    {
      dataField: "amount",
      text: props.t("Amount"),
      formatter: (item) => (
        fixingAmount(item?.amount?.$numberDecimal || item?.amount)
      )
    },
    {
      dataField: "note",
      text: props.t("note"),
      formatter: (item) => (
        item?.note?.length === 0 ? "-" : captilazeFirstLetter(item?.note)
      )
    },
    {
      dataField: "",
      isDummyField: true,
      editable: false,
      text: props.t("Tx-id"), 
      formatter: (item) => (
        <Link to="#">
          <i
            className="mdi mdi-clipboard font-size-18"
            id="preview"
            onClick={ () => {navigator.clipboard.writeText(item.txId)} }
          ></i>
        </Link>
      )
    },
    {
      dataField: "origin",
      isDummyField: true,
      editable: false,
      text: props.t("Origin"),
      formatter: (item) => <OriginDetailsButton origin={item.origin} />,
    },
    selectedTransactionType === "Deposit" &&
    {
      dataField: "",
      isDummyField: true,
      editable: false,
      text: props.t("Actions"),
      formatter: (item) => (
        <UncontrolledDropdown>
          <DropdownToggle tag="i" className="text-muted" style={{ cursor: "pointer" }}>
            <i className="mdi mdi-dots-horizontal font-size-18" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
              onClick={() => {depositApproveModal(item)}} 
              href="#">{props.t("Approve")}
            </DropdownItem>
            <DropdownItem 
              onClick={() => {depositRejectModal(item)}}
              href="#">{props.t("Reject")}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      )
    },
    selectedTransactionType === "Withdrawal" &&
    {
      dataField: "",
      isDummyField: true,
      editable: false,
      text: props.t("Actions"),
      formatter: (item) => (
        <UncontrolledDropdown>
          <DropdownToggle tag="i" className="text-muted" style={{ cursor: "pointer" }}>
            <i className="mdi mdi-dots-horizontal font-size-18" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem 
              onClick={() => {withdrawApprove(item)}} 
              href="#">{props.t("Approve")}
            </DropdownItem>
            <DropdownItem 
              onClick={() => {withdrawReject(item)}}
              href="#">{props.t("Reject")}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      )
    },
  ];

  return (
    <React.Fragment>
      <div className="">
        <div className="container-fluid">
          {/* notification if selected transaction type is deposit */}
          {/* {selectedTransactionType === "Deposit" && 
            <Notification
              onClose={closeNotifaction}
              body={props.t("The deposit has been updated successfully")}
              show={showNotication}
              header={props.t("Deposit Update")}
              logo={logo}
            />
          } */}
          {/* notification if selected transaction type is withdrawal */}
          {/* {selectedTransactionType === "Withdrawal" && 
            <Notification onClose={closeNotifaction}
              body={props.t("The update of the withdraw has been made successfully")}
              show={showNotication}
              header={props.t("Withdraw update")}
              time={props.t("Now")}
              logo={logo}
            />
          } */}
          <Row>
            <Col className="col-12">
              <Card>
                <CardHeader className="d-flex justify-content-between  align-items-center">
                  <CardTitle className="color-primary">
                    {props.t("Transactions list")} ({selectedTransactionType === "Withdrawal" ? props.withdrawalsTotalDocs : props.depositsTotalDocs})
                  </CardTitle>
                  <Dropdown
                    isOpen={btnprimary1}
                    toggle={() => {setBtnprimary1(!btnprimary1)}}
                  >
                    <DropdownToggle tag="button" className="btn btn-primary">
                      {transactionTypes.find(t => t.key === selectedTransactionType)?.label} <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu>
                      {transactionTypes.map((type) => (
                        <DropdownItem 
                          key={type.key}
                          onClick={() => changeTransactionTypeHandler(type.key)}
                        >
                          {type.label}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </CardHeader>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div
                      className="table-responsive mb-0"
                      data-pattern="priority-columns"
                    >
                      <Table
                        id="tech-companies-1"
                        className="table  table-hover "
                      >
                        <Thead className="text-center table-light" >
                          <Tr>
                            {columns.map((column, index) =>
                              <Th data-priority={index} key={index}><span className="color-primary">{column.text}</span></Th>
                            )}
                          </Tr>
                        </Thead>
                        {/* if no records show "No records" otherwise show records */}
                        {
                          // if deposits is selected then render clientDeposits
                          selectedTransactionType === "Deposit"
                            ?
                            // if deposits is selected but no data to show
                            props.depositsTotalDocs === 0 
                              ?
                              <Tbody>
                                {props.loading && <TableLoader colSpan={4} />}                            
                                {!props.loading && /*props.totalDocs === 0 && */
                                  <>
                                    <Tr>
                                      <Td colSpan={"100%"} className="fw-bolder text-center" st="true">
                                        <h3 className="fw-bolder text-center">{props.t("No records")}</h3>
                                      </Td>
                                    </Tr>
                                  </>
                                }
                              </Tbody>
                              :
                              // if deposits is selected and there is data to show
                              <Tbody style = {{
                                fontSize: "12px",
                                textAlign: "center",
                                textTransform: "capitalize"
                              }}>
                                {props.loading && <TableLoader colSpan={4} />}
                                {!props.depositLoading && props.clientDeposits?.map((row, rowIndex) =>
                                  <Tr key={rowIndex}>
                                    {columns.map((column, index) =>
                                      <Td key={`${rowIndex}-${index}`}>
                                        { column.dataField === "checkbox" ? <input type="checkbox"/> : ""}
                                        { column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                                      </Td>
                                    )}
                                  </Tr>
                                )}
                              </Tbody>
                            :
                            // if withdrawals is selected 
                            props.withdrawalsTotalDocs === 0 
                              ?
                              // if withdrawals is seleceted but no data to show
                              <Tbody>
                                {props.loading && <TableLoader colSpan={4} />}  
                                {!props.withdrawalLoading &&
                                  <>
                                    <Tr>
                                      <Td colSpan={"100%"} className="fw-bolder text-center" st="true">
                                        <h3 className="fw-bolder text-center">{props.t("No records")}</h3>
                                      </Td>
                                    </Tr>
                                  </>
                                }
                              </Tbody>
                              :
                              // if withdrawals is selected and there is data to show
                              <Tbody style = {{
                                fontSize: "12px",
                                textAlign: "center",
                                textTransform: "capitalize"
                              }}>
                                {props.loading && <TableLoader colSpan={4} />}
                                {(!props.loading && props.clientWithdrawals) && props.clientWithdrawals.map((row, rowIndex) =>
                                  <Tr key={rowIndex}>
                                    {columns.map((column, index) =>
                                      <Td key={`${rowIndex}-${index}`}>
                                        { column.dataField === "checkbox" ? <input type="checkbox"/> : ""}
                                        { column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                                      </Td>
                                    )}
                                  </Tr>
                                )}
                              </Tbody>
                        }
                      </Table>
                      {/* if deposits is selected */}
                      {
                        (props.clientDeposits && selectedTransactionType === "Deposit") &&
                        <CustomPagination
                          docs={props.clientDeposits}
                          setSizePerPage={setSizePerPage}
                          sizePerPage={sizePerPage}
                          page={props.clientDepositsPage}
                          totalPages={props.clientDepositsTotalPages}
                          totalDocs={props.depositsTotalDocs}
                          hasNextPage={props.clientDepositsHasNextPage}
                          hasPrevPage={props.clientDepositsHasPrevPage}
                          nextPage={props.clientDepositsNextPage}
                          prevPage={props.clientDepositsPrevPage}
                          onChange={(newPage, newLimit) => {
                            setPage(newPage);
                            loadClientTransactionsdetails(newPage, newLimit);
                          }}
                        />
                      }
                      {/* if withdrawals is selected */}
                      {
                        (props.clientWithdrawals && selectedTransactionType === "Withdrawal") &&
                        <CustomPagination
                          docs={props.clientWithdrawals}
                          setSizePerPage={setSizePerPage}
                          sizePerPage={sizePerPage}
                          page={props.clientWithdrawalsPage}
                          totalPages={props.clientWithdrawalsTotalPages}
                          totalDocs={props.withdrawalsTotalDocs}
                          hasNextPage={props.clientWithdrawalsHasNextPage}
                          hasPrevPage={props.clientWithdrawalsHasPrevPage}
                          nextPage={props.clientWithdrawalsNextPage}
                          prevPage={props.clientWithdrawalsPrevPage}
                          onChange={(newPage, newLimit) => {
                            setPage(newPage);
                            loadClientTransactionsdetails(newPage, newLimit);
                          }}
                        />
                      }
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      {selectedContent && (
        <ReceiptModal
          content={selectedContent}
          open={detailsModal}
          onClose={() => setDetailsModal(false)}
        />
      )}
      {approveModal && <TransactionModal
        show={approveModal}
        title={props.t("Approve Deposit")}
        submitButton="Approve"
        showAmount={true}
        toggle={() => {
          setApproveModal(!approveModal);
        }}
        t={props.t}
        onSubmit={depositApprove}
        data={selectedDeposit}
      >
      </TransactionModal>}
      {rejectModal && <TransactionModal
        show={rejectModal}
        title="Reject Deposit"
        submitButton="Reject"
        showAmount={false}
        toggle={() => {
          setRejectModal(!rejectModal);
        }}
        t={props.t}
        onSubmit={depositReject}
        data={selectedDeposit}
      >
      </TransactionModal>}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  depositLoading: state.depositReducer.loading,
  withdrawalLoading: state.withdrawalReducer.loading,
  error: state.clientReducer.error,
  clientDeposits: state.depositReducer.clientDeposits,
  depositsTotalDocs: state.depositReducer.depositsTotalDocs,
  clientDepositsTotalPages: state.depositReducer.clientDepositsTotalPages,
  clientDepositsPage: state.depositReducer.clientDepositsPage,
  clientDepositsHasNextPage: state.depositReducer.clientDepositsHasNextPage,
  clientDepositsHasPrevPage: state.depositReducer.clientDepositsHasPrevPage,
  clientDepositsNextPage: state.depositReducer.clientDepositsNextPage,
  clientDepositsPrevPage: state.depositReducer.clientDepositsPrevPage,
  clientWithdrawals: state.withdrawalReducer.clientWithdrawals,
  withdrawalsTotalDocs: state.withdrawalReducer.withdrawalsTotalDocs,
  clientWithdrawalsTotalPages: state.withdrawalReducer.clientWithdrawalsTotalPages,
  clientWithdrawalsPage: state.withdrawalReducer.clientWithdrawalsPage,
  clientWithdrawalsHasNextPage: state.withdrawalReducer.clientWithdrawalsHasNextPage,
  clientWithdrawalsHasPrevPage: state.withdrawalReducer.clientWithdrawalsHasPrevPage,
  clientWithdrawalsNextPage: state.withdrawalReducer.clientWithdrawalsNextPage,
  clientWithdrawalsPrevPage: state.withdrawalReducer.clientWithdrawalsPrevPage,
  errorDetails: state.clientReducer.errorDetails,
});

export default connect(mapStateToProps, null)(withTranslation()(ClientTransactions));
